import { type ResourcesConfig } from 'aws-amplify';
import config from 'src/config';

// Docs - https://docs.amplify.aws/javascript/build-a-backend/auth/set-up-auth/
export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: config.cognitoUserPoolId,
      userPoolClientId: config.cognitoUserPoolWebClientId,
      identityPoolId: config.cognitoIdentityPoolId,
      loginWith: {
        oauth: {
          domain: config.cognitoDomain,
          scopes: [
            'openid',
          ],
          redirectSignIn: [config.redirectSignIn],
          redirectSignOut: [config.redirectSignOut],
          responseType: 'code',
        },
      },
    },
  },
};

export const initialUrlKey = 'leelaInitialUrl';
